module.exports = __webpack_public_path__ + "static/img/slider-22.409645a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-22.jpg
// module id = /TOy
// module chunks = 0